module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', {
    attrs: {
      "id": "app"
    }
  }, [(!_vm.maintainer) ? _c('div', [_c('div', [(_vm.$store.state.gen.showLoader) ? _c('div', {
    staticStyle: {
      "display": "flex",
      "flex-wrap": "wrap",
      "align-items": "center",
      "justify-content": "center",
      "width": "100vw",
      "z-index": "1000",
      "height": "100vh",
      "position": "fixed",
      "background-color": "#000000"
    },
    attrs: {
      "onload": this.getQuotes()
    }
  }, [_c('div', {
    staticClass: "loader"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "loader-icon"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/loader/loading-viewZzz.svg",
      "height": "30"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('div', {
    staticClass: "loader-quote"
  }, [_c('p', {
    staticClass: "quoteText"
  }, [_vm._v(_vm._s(_vm.currentQuote.text))]), _vm._v(" "), _c('p', {
    staticClass: "quoteAuthor"
  }, [_vm._v(_vm._s(_vm.currentQuote.author))])])])])]) : _vm._e(), _vm._v(" "), _c('modal', {
    attrs: {
      "clickToClose": false,
      "pivotY": 0.65,
      "width": "309",
      "height": "auto",
      "name": "praise-mode-modal"
    }
  }, [_c('div', {
    staticClass: "modal-main-container-praise"
  }, [_c('div', {
    staticClass: "div-1"
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("blur_circular")])]), _vm._v(" "), _c('div', {
    staticClass: "div-2"
  }, [_c('div', {
    staticClass: "div-2A"
  }, [_vm._v("Welcome to the distraction")]), _vm._v(" "), _c('div', {
    staticClass: "div-2A"
  }, [_vm._v("free praise mode.")]), _vm._v(" "), _c('div', {
    staticClass: "div-2A"
  }, [_vm._v("No text & icons.")])]), _vm._v(" "), _c('div', {
    staticClass: "div-3"
  }, [_c('div', {
    staticClass: "div-A"
  }, [_vm._v("How to exit the praise mode?")]), _vm._v(" "), _c('div', {
    staticClass: "div-B"
  }, [_c('div', {
    staticClass: "text"
  }, [_vm._v("1. Tap anywhere")])])]), _vm._v(" "), _c('div', {
    staticClass: "div-4"
  }, [_c('div', {
    staticClass: "div-4A pointer",
    on: {
      "click": function($event) {
        return _vm.$modal.hide('praise-mode-modal')
      }
    }
  }, [_c('div', {
    staticClass: "div-4AA"
  }, [_vm._v("GOT IT!")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-main-container-loc-parent"
  }, [_c('modal', {
    staticStyle: {
      "z-index": "900000000"
    },
    attrs: {
      "clickToClose": false,
      "width": "309",
      "height": "auto",
      "name": "ask-to-add-to-wishlist"
    }
  }, [_c('div', {
    staticClass: "modal-main-container-loc"
  }, [_c('div', {
    staticClass: "div-1"
  }, [_c('div', {
    staticClass: "div-e1"
  })]), _vm._v(" "), _c('div', {
    staticClass: "div-2"
  }, [_c('div', {
    staticClass: "div-2A"
  }, [_vm._v("To find out exact location or")]), _vm._v(" "), _c('div', {
    staticClass: "div-2A"
  }, [_vm._v("driving directions of a view, it")]), _vm._v(" "), _c('div', {
    staticClass: "div-2A"
  }, [_vm._v("should be on your travel list.")])]), _vm._v(" "), _c('div', {
    staticClass: "div-3"
  }, [_c('div', {
    staticClass: "div-3A"
  }, [_c('div', {
    staticClass: "div-3AA pointer",
    on: {
      "click": function($event) {
        return _vm.addToWishlish()
      }
    }
  }, [_c('div', {
    staticClass: "text"
  }, [_vm._v("Add to travel list")]), _vm._v(" "), _c('div', {
    staticClass: "icon-container"
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("add")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "div-4"
  }, [_c('div', {
    staticClass: "div-4A pointer",
    on: {
      "click": function($event) {
        return _vm.$modal.hide('ask-to-add-to-wishlist')
      }
    }
  }, [_c('div', {
    staticClass: "div-4AA"
  }, [_vm._v("GOT IT!")])])])])])], 1), _vm._v(" "), _c('modal', {
    staticStyle: {
      "z-index": "900000000"
    },
    attrs: {
      "pivotY": 0.65,
      "width": "309",
      "height": "auto",
      "name": "license-modal"
    }
  }, [_c('div', {
    staticClass: "modal-main-container"
  }, [(_vm.$store.state.imageDetails.license !== undefined) ? _c('div', {
    staticClass: "div-2"
  }, [_c('div', {
    staticClass: "div-2A text-xs-left"
  }, [_vm._v("Copyright Information")]), _vm._v(" "), _c('div', {
    staticClass: "div-2A light-blue--text"
  }, [_c('span', {
    staticClass: "pointer",
    on: {
      "click": function($event) {
        return _vm.openInTab(_vm.$store.state.imageDetails.license.licenseLink)
      }
    }
  }, [_vm._v(_vm._s(_vm.$store.state.imageDetails.license.type))]), _vm._v("\n                /\n                "), _c('span', {
    staticClass: "pointer",
    on: {
      "click": function($event) {
        return _vm.openInTab(_vm.$store.state.imageDetails.license.photoSourceLink)
      }
    }
  }, [_vm._v("Photo")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "div-4"
  }, [_c('div', {
    staticClass: "div-4A pointer",
    on: {
      "click": function($event) {
        return _vm.$modal.hide('likes-modal')
      }
    }
  }, [_c('div', {
    staticClass: "div-4AA"
  }, [_c('div', {
    staticClass: "div-3",
    staticStyle: {
      "margin-top": "unset"
    }
  }, [_c('div', {
    staticClass: "div-3AA",
    staticStyle: {
      "font-size": "0.813em"
    }
  }, [_vm._v("\n                      Report any copyright violations to contact@withaview.co\n                    ")])])])])])])]), _vm._v(" "), _c('modal', {
    staticStyle: {
      "z-index": "900000000"
    },
    attrs: {
      "clickToClose": false,
      "pivotY": 0.82,
      "width": "309",
      "height": "158",
      "name": "location-modal"
    }
  }, [_c('div', {
    staticClass: "praise-mode-modal"
  }, [_c('div', {
    staticClass: "top"
  }, [_c('div', {
    staticClass: "text-loc",
    staticStyle: {
      "letter-spacing": "0.13em"
    }
  }, [_vm._v("\n                Do you want to know how far is this view from you?\n              ")])]), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  }, [_c('div', {
    staticClass: "buttons"
  }, [_c('div', {
    staticClass: "no",
    on: {
      "click": function($event) {
        return _vm.$modal.hide('location-modal')
      }
    }
  }, [_vm._v("NO")]), _vm._v(" "), _c('div', {
    staticClass: "yes",
    on: {
      "click": function($event) {
        _vm.saveLocAllowedInLs();
        _vm.getLocationFinal();
      }
    }
  }, [_vm._v("\n                  YES\n                ")])])])])]), _vm._v(" "), (_vm.showOverlay) ? _c('div', {
    style: (("display: " + (_vm.showOverlay === true ? 'block' : 'none'))),
    attrs: {
      "id": "overlay"
    },
    on: {
      "click": function($event) {
        _vm.$store.state.common.showOverlay = false
      }
    }
  }, [_c('div', {
    staticStyle: {
      "position": "relative"
    }
  }, [_c('img', {
    staticStyle: {
      "position": "absolute",
      "right": "2px",
      "top": "10px",
      "height": "100px"
    },
    attrs: {
      "src": require("../static/img/overlay/ARROW.png")
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "color": "#ffffff",
      "font-weight": "400",
      "font-family": "Avenir, Helvetica, Arial, sans-serif",
      "position": "absolute",
      "top": "90px",
      "right": "110px",
      "font-size": "14px",
      "left": "10px"
    }
  }, [_vm._v("\n              Location has been blocked from the browser, To turn on location,\n              go to → Settings → Site settings/Content settings\n              → Location → Blocked →\n              https://www.withaview.co → Permissions → Location\n              access: Allow/Delete\n            ")])])]) : _vm._e(), _vm._v(" "), (_vm.dbRefLoader || _vm.authLoader) ? _c('div') : _c('div', [_c('main', {
    class: ("bottom-menu-class-" + (_vm.$store.state.common.isbottomMenuOpen))
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in",
      "appear": ""
    },
    on: {
      "after-enter": function($event) {}
    }
  }, [_c('router-view')], 1)], 1)]), _vm._v(" "), (_vm.isbottomMenuOpen) ? _c('div', {
    staticClass: "bottom-menu",
    attrs: {
      "id": "bottom-menu"
    }
  }, [_c('bottom-menu')], 1) : _vm._e(), _vm._v(" "), _c('snackbar_alert'), _vm._v(" "), _c('v-bottom-sheet', {
    staticStyle: {
      "z-index": "2000"
    },
    model: {
      value: (_vm.$store.state.gen.sheet),
      callback: function($$v) {
        _vm.$set(_vm.$store.state.gen, "sheet", $$v)
      },
      expression: "$store.state.gen.sheet"
    }
  }, [_c('v-list', [_c('v-subheader', [_vm._v("Share via")]), _vm._v(" "), _vm._l((_vm.tiles), function(tile) {
    return _c('v-list-tile', {
      key: tile.title,
      on: {
        "click": function($event) {
          _vm.$store.state.gen.sheet = false;
          tile.func();
        }
      }
    }, [_c('v-list-tile-avatar', [_c('v-avatar', {
      attrs: {
        "size": "32px",
        "tile": ""
      }
    }, [_c('v-lazy-image', {
      attrs: {
        "src": tile.img,
        "alt": tile.title
      }
    })], 1)], 1), _vm._v(" "), _c('v-list-tile-title', [_vm._v(_vm._s(tile.title))])], 1)
  })], 2)], 1)], 1)]) : _c('maintainer')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-35706ddf","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 524
// module chunks = 17